import { DeviceGroupPolicyValidationContext } from './device-group-policy-validation-context';
import { DeviceGroupPolicyVaultOperation } from './device-group-policy-vault-operation';
export class DeviceGroupPolicyVault {
    constructor(entries) {
        this.entries = [];
        this.entries = entries.sort((a, b) => a.entryId - b.entryId);
    }
    static async Create(entries, keyVault, groupVault, allowEmpty = false, validateFromEntry) {
        const vault = new DeviceGroupPolicyVault(entries);
        const validationContext = new DeviceGroupPolicyValidationContext(entries, keyVault, groupVault, allowEmpty, validateFromEntry);
        await validationContext.validateAll();
        return vault;
    }
    effectiveGroupPolicyEntries(policyType) {
        let result = [];
        let globalEntries = this.entries
            .filter(e => e.operation === DeviceGroupPolicyVaultOperation.AddPolicy ||
            e.operation === DeviceGroupPolicyVaultOperation.RemovePolicy ||
            e.operation === DeviceGroupPolicyVaultOperation.ReplacePolicy);
        if (policyType !== null) {
            globalEntries = globalEntries.filter(e => e.policyType === policyType ||
                (e.operation === DeviceGroupPolicyVaultOperation.RemovePolicy || e.operation === DeviceGroupPolicyVaultOperation.ReplacePolicy));
        }
        for (const entry of globalEntries) {
            switch (entry.operation) {
                case DeviceGroupPolicyVaultOperation.AddPolicy:
                    result.push({ groupId: entry.groupId, policyId: entry.policyId, policyHash: entry.policyHash, policyType: entry.policyType });
                    break;
                case DeviceGroupPolicyVaultOperation.ReplacePolicy:
                    result = result.map(resultEntry => {
                        if (resultEntry.policyId !== entry.replacedPolicyId) {
                            return resultEntry;
                        }
                        return { policyId: entry.policyId, policyHash: entry.policyHash, groupId: resultEntry.groupId, policyType: resultEntry.policyType };
                    });
                    break;
                case DeviceGroupPolicyVaultOperation.RemovePolicy:
                    result = result.filter(e => !(e.groupId === entry.groupId && e.policyId === entry.policyId));
                    break;
            }
        }
        return result;
    }
    effectiveGlobalPolicyEntries(policyType) {
        let result = [];
        let globalEntries = this.entries
            .filter(e => e.operation === DeviceGroupPolicyVaultOperation.AddGlobalPolicy ||
            e.operation === DeviceGroupPolicyVaultOperation.RemoveGlobalPolicy ||
            e.operation === DeviceGroupPolicyVaultOperation.ReplacePolicy);
        if (policyType !== null) {
            globalEntries = globalEntries.filter(e => e.policyType === policyType ||
                (e.operation === DeviceGroupPolicyVaultOperation.RemoveGlobalPolicy || e.operation === DeviceGroupPolicyVaultOperation.ReplacePolicy));
        }
        for (const entry of globalEntries) {
            switch (entry.operation) {
                case DeviceGroupPolicyVaultOperation.AddGlobalPolicy:
                    result.push({ groupId: null, policyId: entry.policyId, policyHash: entry.policyHash, policyType: entry.policyType });
                    break;
                case DeviceGroupPolicyVaultOperation.ReplacePolicy:
                    result = result.map(resultEntry => {
                        if (resultEntry.policyId !== entry.replacedPolicyId) {
                            return resultEntry;
                        }
                        return { policyId: entry.policyId, policyHash: entry.policyHash, groupId: null, policyType: resultEntry.policyType };
                    });
                    break;
                case DeviceGroupPolicyVaultOperation.RemoveGlobalPolicy:
                    result = result.filter(e => e.policyId !== entry.policyId);
                    break;
            }
        }
        return result;
    }
    effectiveReplaceEntriesAt(at = null) {
        let result = this.entries.filter(e => e.operation === DeviceGroupPolicyVaultOperation.ReplacePolicy);
        if (at !== null) {
            result = result.filter(e => e.addedAt <= at);
        }
        return result;
    }
    getLastEntry() {
        return this.entries.length > 0 ? this.entries[this.entries.length - 1] : null;
    }
}
